import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Box, IconButton } from "@mui/material";
import { useIconButtonLightStyles } from "../button/useIconButtonStyles.js";
const transparent = {
    backgroundImage: `linear-gradient(45deg, #eee 25%, transparent 25%),
      linear-gradient(45deg, transparent 75%, #eee 75%),
      linear-gradient(45deg, transparent 75%, #eee 75%),
      linear-gradient(45deg, #eee 25%, #fff 25%)`,
    backgroundSize: "16px 16px",
    backgroundPosition: "0 0, 0 0, -8px -8px, 8px 8px",
};
const defaultRenderButton = (button) => button;
export const Image = ({ title, loading, disabled, handleDelete, borderRadius, style, renderDeleteButton = defaultRenderButton, ...imgAttributes }) => {
    const { classes: classesIconButtonLight } = useIconButtonLightStyles();
    return (_jsxs(Box, { position: "relative", display: "flex", height: "100%", overflow: "hidden", flexDirection: "column", justifyContent: "center", style: {
            maxHeight: "min-content",
            borderRadius,
            ...transparent,
            ...(handleDelete ? { minHeight: 72 } : { minHeight: 0 }),
        }, onClick: e => {
            e.stopPropagation();
        }, children: [_jsx("img", { alt: title, ...imgAttributes, style: {
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                    borderRadius: "inherit",
                    ...style,
                    // cursor: "pointer",
                } }), handleDelete &&
                renderDeleteButton(_jsx(Box, { position: "absolute", right: "12px", bottom: "12px", children: _jsx(IconButton, { color: "primary", classes: classesIconButtonLight, onClick: handleDelete, disabled: loading || disabled, size: "large", children: _jsx(DeleteIcon, {}) }) }))] }));
};
//# sourceMappingURL=Image.js.map